import React from 'react'

const Flpkrt6 = () => {
    return (
        <div className='container'>
        <h1>Design a stack that supports getMin() in O(1) time and O(1) extra space</h1>
           <div>
    <p><strong>Question:</strong> Design a Data Structure SpecialStack that supports all the stack operations like
        push(), pop(), isEmpty(), isFull() and an additional operation getMin() which should return minimum element from
        the SpecialStack. All these operations of SpecialStack must be O(1). To implement SpecialStack, you should only
        use standard Stack data structure and no other data structure like arrays, list, ..
        etc.&nbsp;<br/>Example:&nbsp;<br/>&nbsp;</p>
    <pre>Consider the following SpecialStack
    16  --&gt; TOP
    15
    29
    19
    18
    
    When getMin() is called it should return 15, 
    which is the minimum element in the current stack. 
    
    If we do pop two times on stack, the stack becomes
    29  --&gt; TOP
    19
    18
    
    When getMin() is called, it should return 18 
    which is the minimum in the current stack.</pre>
    <p>&nbsp;</p>
     <p>An approach that uses O(1) time and O(n) extra space is discussed <a
            href="https://www.geeksforgeeks.org/design-and-implement-special-stack-data-structure/">here</a>.<br/>In this
        article, a new approach is discussed that supports minimum with O(1) extra space. We define a variable
        <strong>minEle</strong> that stores the current minimum element in the stack. Now the interesting part is, how
        to handle the case when minimum element is removed. To handle this, we push “2x – minEle” into the stack instead
        of x so that previous minimum element can be retrieved using current minEle and its value stored in stack. Below
        are detailed steps and explanation of working.<br/><strong>Push(x)</strong> : Inserts x at the top of
        stack.&nbsp;<br/>&nbsp;</p>
    <ul>
        <li>If stack is empty, insert x into the stack and make minEle equal to x.</li>
        <li>If stack is not empty, compare x with minEle. Two cases arise:<ul>
                <li>If x is greater than or equal to minEle, simply insert x.</li>
                <li>If x is less than minEle, insert (2*x – minEle) into the stack and make minEle equal to x. For
                    example, let previous minEle was 3. Now we want to insert 2. We update minEle as 2 and insert 2*2 –
                    3 = 1 into the stack.</li>
            </ul>
        </li>
    </ul>
    <p><strong>Pop() : </strong>Removes an element from top of stack.&nbsp;<br/>&nbsp;</p>
    <ul>
        <li>Remove element from top. Let the removed element be y. Two cases arise:<ul>
                <li>If y is greater than or equal to minEle, the minimum element in the stack is still minEle.</li>
                <li>If y is less than minEle, the minimum element now becomes (2*minEle – y), so update (minEle =
                    2*minEle – y). This is where we retrieve previous minimum from current minimum and its value in
                    stack. For example, let the element to be removed be 1 and minEle be 2. We remove 1 and update
                    minEle as 2*2 – 1 = 3.</li>
            </ul>
        </li>
    </ul>
    <p><strong>Important Points:</strong>&nbsp;<br/>&nbsp;</p><br/>
   
    <ul>
        <li>Stack doesn’t hold actual value of an element if it is minimum so far.</li>
        <li>Actual minimum element is always stored in minEle</li>
    </ul>
   
    <ul>
        <li>Number to be Inserted: 3, Stack is empty, so insert 3 into stack and minEle = 3.</li>
        <li>Number to be Inserted: 5, Stack is not empty, 5&gt; minEle, insert 5 into stack and minEle = 3.</li>
        <li>Number to be Inserted: 2, Stack is not empty, 2&lt; minEle, insert (2*2-3 = 1) into stack and minEle = 2.
        </li>
        <li>Number to be Inserted: 1, Stack is not empty, 1&lt; minEle, insert (2*1-2 = 0) into stack and minEle = 1.
        </li>
        <li>Number to be Inserted: 1, Stack is not empty, 1 = minEle, insert 1 into stack and minEle = 1.</li>
        <li>Number to be Inserted: -1, Stack is not empty, -1 &lt; minEle, insert (2*-1 – 1 = -3) into stack and minEle
            = -1.</li>
    </ul>
    <p>&nbsp;</p>
   
    </div><br/>
    <ul>
        <li>Initially the minimum element minEle in the stack is -1.</li>
        <li>Number removed: -3, Since -3 is less than the minimum element the original number being removed is minEle
            which is -1, and the new minEle = 2*-1 – (-3) = 1</li>
        <li>Number removed: 1, 1 == minEle, so number removed is 1 and minEle is still equal to 1.</li>
        <li>Number removed: 0, 0&lt; minEle, original number is minEle which is 1 and new minEle = 2*1 – 0 = 2.</li>
        <li>Number removed: 1, 1&lt; minEle, original number is minEle which is 2 and new minEle = 2*2 – 1 = 3.</li>
        <li>Number removed: 5, 5&gt; minEle, original number is 5 and minEle is still 3</li>
    </ul>
    <p>&nbsp;</p>
   


        <div class="tabs">
<input type="radio" name="tab" id="tab1" />
<label for="tab1">CPP</label>
<input type="radio" name="tab" id="tab2"/>
<label for="tab2">Java </label>
<input type="radio" name="tab" id="tab3"/>
<label for="tab3">Python</label>



<div class="tab-content-wrapper">
 <div id="tab-content-1" class="tab-content">
 <div class="container">
    <div class="line number1 index0 alt2"><code
            class="comments">// C++ program to implement a stack that supports</code></div>
    <div class="line number2 index1 alt1"><code
            class="comments">// getMinimum() in O(1) time and O(1) extra space.</code></div>
    <div class="line number3 index2 alt2"><code class="preprocessor">#include &lt;bits/stdc++.h&gt;</code></div>
    <div class="line number4 index3 alt1"><code class="keyword bold">using</code> <code
            class="keyword bold">namespace</code> <code class="plain">std;</code></div>
    <div class="line number5 index4 alt2">&nbsp;</div>
    <div class="line number6 index5 alt1"><code
            class="comments">// A user defined stack that supports getMin() in</code></div>
    <div class="line number7 index6 alt2"><code class="comments">// addition to push() and pop()</code></div>
    <div class="line number8 index7 alt1"><code class="keyword bold">struct</code> <code class="plain">MyStack</code>
    </div>
    <div class="line number9 index8 alt2"><code class="plain">&#123;</code></div>
    <div class="line number10 index9 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">stack&lt;</code><code class="color1 bold">int</code><code class="plain">&gt; s;</code></div>
    <div class="line number11 index10 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1 bold">int</code> <code class="plain">minEle;</code></div>
    <div class="line number12 index11 alt1">&nbsp;</div>
    <div class="line number13 index12 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// Prints minimum element of MyStack</code></div>
    <div class="line number14 index13 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">void</code> <code class="plain">getMin()</code></div>
    <div class="line number15 index14 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#123;</code></div>
    <div class="line number16 index15 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">if</code> <code class="plain">(s.empty())</code></div>
    <div class="line number17 index16 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">cout &lt;&lt; </code><code class="string">"Stack is empty\n"</code><code
            class="plain">;</code></div>
    <div class="line number18 index17 alt1">&nbsp;</div>
    <div class="line number19 index18 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// variable minEle stores the minimum element</code></div>
    <div class="line number20 index19 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// in the stack.</code></div>
    <div class="line number21 index20 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">else</code></div>
    <div class="line number22 index21 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">cout &lt;&lt;</code><code class="string">"Minimum Element in the stack is: "</code></div>
    <div class="line number23 index22 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&lt;&lt; minEle &lt;&lt; </code><code class="string">"\n"</code><code class="plain">;</code>
    </div>
    <div class="line number24 index23 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number25 index24 alt2">&nbsp;</div>
    <div class="line number26 index25 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// Prints top element of MyStack</code></div>
    <div class="line number27 index26 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">void</code> <code class="plain">peek()</code></div>
    <div class="line number28 index27 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#123;</code></div>
    <div class="line number29 index28 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">if</code> <code class="plain">(s.empty())</code></div>
    <div class="line number30 index29 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#123;</code>
    </div>
    <div class="line number31 index30 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">cout &lt;&lt; </code><code class="string">"Stack is empty "</code><code class="plain">;</code>
    </div>
    <div class="line number32 index31 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">return</code><code class="plain">;</code></div>
    <div class="line number33 index32 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code>
    </div>
    <div class="line number34 index33 alt1">&nbsp;</div>
    <div class="line number35 index34 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1 bold">int</code> <code class="plain">t = s.top(); </code><code
            class="comments">// Top element.</code></div>
    <div class="line number36 index35 alt1">&nbsp;</div>
    <div class="line number37 index36 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">cout &lt;&lt; </code><code class="string">"Top Most Element is: "</code><code
            class="plain">;</code></div>
    <div class="line number38 index37 alt1">&nbsp;</div>
    <div class="line number39 index38 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// If t &lt; minEle means minEle stores</code></div>
    <div class="line number40 index39 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// value of t.</code></div>
    <div class="line number41 index40 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">(t &lt; minEle)? cout &lt;&lt; minEle: cout &lt;&lt; t;</code></div>
    <div class="line number42 index41 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number43 index42 alt2">&nbsp;</div>
    <div class="line number44 index43 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// Remove the top element from MyStack</code></div>
    <div class="line number45 index44 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">void</code> <code class="plain">pop()</code></div>
    <div class="line number46 index45 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#123;</code></div>
    <div class="line number47 index46 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">if</code> <code class="plain">(s.empty())</code></div>
    <div class="line number48 index47 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#123;</code>
    </div>
    <div class="line number49 index48 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">cout &lt;&lt; </code><code class="string">"Stack is empty\n"</code><code
            class="plain">;</code></div>
    <div class="line number50 index49 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">return</code><code class="plain">;</code></div>
    <div class="line number51 index50 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code>
    </div>
    <div class="line number52 index51 alt1">&nbsp;</div>
    <div class="line number53 index52 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">cout &lt;&lt; </code><code class="string">"Top Most Element Removed: "</code><code
            class="plain">;</code></div>
    <div class="line number54 index53 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1 bold">int</code> <code class="plain">t = s.top();</code></div>
    <div class="line number55 index54 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">s.pop();</code></div>
    <div class="line number56 index55 alt1">&nbsp;</div>
    <div class="line number57 index56 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// Minimum will change as the minimum element</code></div>
    <div class="line number58 index57 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// of the stack is being removed.</code></div>
    <div class="line number59 index58 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">if</code> <code class="plain">(t &lt; minEle)</code></div>
    <div class="line number60 index59 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#123;</code>
    </div>
    <div class="line number61 index60 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">cout &lt;&lt; minEle &lt;&lt; </code><code class="string">"\n"</code><code
            class="plain">;</code></div>
    <div class="line number62 index61 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">minEle = 2*minEle - t;</code></div>
    <div class="line number63 index62 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code>
    </div>
    <div class="line number64 index63 alt1">&nbsp;</div>
    <div class="line number65 index64 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">else</code></div>
    <div class="line number66 index65 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">cout &lt;&lt; t &lt;&lt; </code><code class="string">"\n"</code><code class="plain">;</code>
    </div>
    <div class="line number67 index66 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number68 index67 alt1">&nbsp;</div>
    <div class="line number69 index68 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// Removes top element from MyStack</code></div>
    <div class="line number70 index69 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">void</code> <code class="plain">push(</code><code class="color1 bold">int</code> <code
            class="plain">x)</code></div>
    <div class="line number71 index70 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#123;</code></div>
    <div class="line number72 index71 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// Insert new number into the stack</code></div>
    <div class="line number73 index72 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">if</code> <code class="plain">(s.empty())</code></div>
    <div class="line number74 index73 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#123;</code>
    </div>
    <div class="line number75 index74 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">minEle = x;</code></div>
    <div class="line number76 index75 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">s.push(x);</code></div>
    <div class="line number77 index76 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">cout &lt;&lt;&nbsp; </code><code class="string">"Number Inserted: "</code> <code
            class="plain">&lt;&lt; x &lt;&lt; </code><code class="string">"\n"</code><code class="plain">;</code></div>
    <div class="line number78 index77 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">return</code><code class="plain">;</code></div>
    <div class="line number79 index78 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code>
    </div>
    <div class="line number80 index79 alt1">&nbsp;</div>
    <div class="line number81 index80 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// If new number is less than minEle</code></div>
    <div class="line number82 index81 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">if</code> <code class="plain">(x &lt; minEle)</code></div>
    <div class="line number83 index82 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#123;</code>
    </div>
    <div class="line number84 index83 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">s.push(2*x - minEle);</code></div>
    <div class="line number85 index84 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">minEle = x;</code></div>
    <div class="line number86 index85 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code>
    </div>
    <div class="line number87 index86 alt2">&nbsp;</div>
    <div class="line number88 index87 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">else</code></div>
    <div class="line number89 index88 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">s.push(x);</code></div>
    <div class="line number90 index89 alt1">&nbsp;</div>
    <div class="line number91 index90 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">cout &lt;&lt;&nbsp; </code><code class="string">"Number Inserted: "</code> <code
            class="plain">&lt;&lt; x &lt;&lt; </code><code class="string">"\n"</code><code class="plain">;</code></div>
    <div class="line number92 index91 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number93 index92 alt2"><code class="plain">&#125;;</code></div>
    <div class="line number94 index93 alt1">&nbsp;</div>
    <div class="line number95 index94 alt2"><code class="comments">// Driver Code</code></div>
    <div class="line number96 index95 alt1"><code class="color1 bold">int</code> <code class="plain">main()</code></div>
    <div class="line number97 index96 alt2"><code class="plain">&#123;</code></div>
    <div class="line number98 index97 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">MyStack s;</code></div>
    <div class="line number99 index98 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">s.push(3);</code></div>
    <div class="line number100 index99 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">s.push(5);</code></div>
    <div class="line number101 index100 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">s.getMin();</code></div>
    <div class="line number102 index101 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">s.push(2);</code></div>
    <div class="line number103 index102 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">s.push(1);</code></div>
    <div class="line number104 index103 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">s.getMin();</code></div>
    <div class="line number105 index104 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">s.pop();</code></div>
    <div class="line number106 index105 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">s.getMin();</code></div>
    <div class="line number107 index106 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">s.pop();</code></div>
    <div class="line number108 index107 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">s.peek();</code></div>
    <div class="line number109 index108 alt2">&nbsp;</div>
    <div class="line number110 index109 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">return</code> <code class="plain">0;</code></div>
    <div class="line number111 index110 alt2"><code class="plain">&#125;</code></div>
</div>
</div>
 <div id="tab-content-2" class="tab-content">
 <div class="container">
    <div class="line number1 index0 alt2"><code
            class="comments">// Java program to implement a stack that supports</code></div>
    <div class="line number2 index1 alt1"><code
            class="comments">// getMinimum() in O(1) time and O(1) extra space.</code></div>
    <div class="line number3 index2 alt2"><code class="keyword">import</code> <code class="plain">java.util.*;</code>
    </div>
    <div class="line number4 index3 alt1">&nbsp;</div>
    <div class="line number5 index4 alt2"><code
            class="comments">// A user defined stack that supports getMin() in</code></div>
    <div class="line number6 index5 alt1"><code class="comments">// addition to push() and pop()</code></div>
    <div class="line number7 index6 alt2"><code class="keyword">class</code> <code class="plain">MyStack</code></div>
    <div class="line number8 index7 alt1"><code class="plain">&#123;</code></div>
    <div class="line number9 index8 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">Stack&lt;Integer&gt; s;</code></div>
    <div class="line number10 index9 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">Integer minEle;</code></div>
    <div class="line number11 index10 alt2">&nbsp;</div>
    <div class="line number12 index11 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// Constructor</code></div>
    <div class="line number13 index12 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">MyStack() &#123; s = </code><code class="keyword">new</code> <code
            class="plain">Stack&lt;Integer&gt;(); &#125;</code></div>
    <div class="line number14 index13 alt1">&nbsp;</div>
    <div class="line number15 index14 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// Prints minimum element of MyStack</code></div>
    <div class="line number16 index15 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">void</code> <code class="plain">getMin()</code></div>
    <div class="line number17 index16 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#123;</code></div>
    <div class="line number18 index17 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// Get the minimum number in the entire stack</code></div>
    <div class="line number19 index18 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">if</code> <code class="plain">(s.isEmpty())</code></div>
    <div class="line number20 index19 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">System.out.println(</code><code class="string">"Stack is empty"</code><code
            class="plain">);</code></div>
    <div class="line number21 index20 alt2">&nbsp;</div>
    <div class="line number22 index21 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// variable minEle stores the minimum element</code></div>
    <div class="line number23 index22 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// in the stack.</code></div>
    <div class="line number24 index23 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">else</code></div>
    <div class="line number25 index24 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">System.out.println(</code><code class="string">"Minimum Element in the "</code> <code
            class="plain">+</code></div>
    <div class="line number26 index25 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="string">" stack is: "</code> <code class="plain">+ minEle);</code></div>
    <div class="line number27 index26 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number28 index27 alt1">&nbsp;</div>
    <div class="line number29 index28 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// prints top element of MyStack</code></div>
    <div class="line number30 index29 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">void</code> <code class="plain">peek()</code></div>
    <div class="line number31 index30 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#123;</code></div>
    <div class="line number32 index31 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">if</code> <code class="plain">(s.isEmpty())</code></div>
    <div class="line number33 index32 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#123;</code>
    </div>
    <div class="line number34 index33 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">System.out.println(</code><code class="string">"Stack is empty "</code><code
            class="plain">);</code></div>
    <div class="line number35 index34 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">return</code><code class="plain">;</code></div>
    <div class="line number36 index35 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code>
    </div>
    <div class="line number37 index36 alt2">&nbsp;</div>
    <div class="line number38 index37 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">Integer t = s.peek(); </code><code class="comments">// Top element.</code></div>
    <div class="line number39 index38 alt2">&nbsp;</div>
    <div class="line number40 index39 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">System.out.print(</code><code class="string">"Top Most Element is: "</code><code
            class="plain">);</code></div>
    <div class="line number41 index40 alt2">&nbsp;</div>
    <div class="line number42 index41 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// If t &lt; minEle means minEle stores</code></div>
    <div class="line number43 index42 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// value of t.</code></div>
    <div class="line number44 index43 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">if</code> <code class="plain">(t &lt; minEle)</code></div>
    <div class="line number45 index44 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">System.out.println(minEle);</code></div>
    <div class="line number46 index45 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">else</code></div>
    <div class="line number47 index46 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">System.out.println(t);</code></div>
    <div class="line number48 index47 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number49 index48 alt2">&nbsp;</div>
    <div class="line number50 index49 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// Removes the top element from MyStack</code></div>
    <div class="line number51 index50 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">void</code> <code class="plain">pop()</code></div>
    <div class="line number52 index51 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#123;</code></div>
    <div class="line number53 index52 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">if</code> <code class="plain">(s.isEmpty())</code></div>
    <div class="line number54 index53 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#123;</code>
    </div>
    <div class="line number55 index54 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">System.out.println(</code><code class="string">"Stack is empty"</code><code
            class="plain">);</code></div>
    <div class="line number56 index55 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">return</code><code class="plain">;</code></div>
    <div class="line number57 index56 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code>
    </div>
    <div class="line number58 index57 alt1">&nbsp;</div>
    <div class="line number59 index58 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">System.out.print(</code><code class="string">"Top Most Element Removed: "</code><code
            class="plain">);</code></div>
    <div class="line number60 index59 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">Integer t = s.pop();</code></div>
    <div class="line number61 index60 alt2">&nbsp;</div>
    <div class="line number62 index61 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// Minimum will change as the minimum element</code></div>
    <div class="line number63 index62 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// of the stack is being removed.</code></div>
    <div class="line number64 index63 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">if</code> <code class="plain">(t &lt; minEle)</code></div>
    <div class="line number65 index64 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#123;</code>
    </div>
    <div class="line number66 index65 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">System.out.println(minEle);</code></div>
    <div class="line number67 index66 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">minEle = </code><code class="value">2</code><code class="plain">*minEle - t;</code></div>
    <div class="line number68 index67 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code>
    </div>
    <div class="line number69 index68 alt2">&nbsp;</div>
    <div class="line number70 index69 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">else</code></div>
    <div class="line number71 index70 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">System.out.println(t);</code></div>
    <div class="line number72 index71 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number73 index72 alt2">&nbsp;</div>
    <div class="line number74 index73 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// Insert new number into MyStack</code></div>
    <div class="line number75 index74 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">void</code> <code class="plain">push(Integer x)</code></div>
    <div class="line number76 index75 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#123;</code></div>
    <div class="line number77 index76 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">if</code> <code class="plain">(s.isEmpty())</code></div>
    <div class="line number78 index77 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#123;</code>
    </div>
    <div class="line number79 index78 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">minEle = x;</code></div>
    <div class="line number80 index79 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">s.push(x);</code></div>
    <div class="line number81 index80 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">System.out.println(</code><code class="string">"Number Inserted: "</code> <code
            class="plain">+ x);</code></div>
    <div class="line number82 index81 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">return</code><code class="plain">;</code></div>
    <div class="line number83 index82 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code>
    </div>
    <div class="line number84 index83 alt1">&nbsp;</div>
    <div class="line number85 index84 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// If new number is less than original minEle</code></div>
    <div class="line number86 index85 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">if</code> <code class="plain">(x &lt; minEle)</code></div>
    <div class="line number87 index86 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#123;</code>
    </div>
    <div class="line number88 index87 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">s.push(</code><code class="value">2</code><code class="plain">*x - minEle);</code></div>
    <div class="line number89 index88 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">minEle = x;</code></div>
    <div class="line number90 index89 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code>
    </div>
    <div class="line number91 index90 alt2">&nbsp;</div>
    <div class="line number92 index91 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">else</code></div>
    <div class="line number93 index92 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">s.push(x);</code></div>
    <div class="line number94 index93 alt1">&nbsp;</div>
    <div class="line number95 index94 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">System.out.println(</code><code class="string">"Number Inserted: "</code> <code
            class="plain">+ x);</code></div>
    <div class="line number96 index95 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number97 index96 alt2"><code class="plain">&#125;;</code></div>
    <div class="line number98 index97 alt1">&nbsp;</div>
    <div class="line number99 index98 alt2"><code class="comments">// Driver Code</code></div>
    <div class="line number100 index99 alt1"><code class="keyword">public</code> <code class="keyword">class</code>
        <code class="plain">Main</code></div>
    <div class="line number101 index100 alt2"><code class="plain">&#123;</code></div>
    <div class="line number102 index101 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">public</code> <code class="keyword">static</code> <code class="keyword">void</code> <code
            class="plain">main(String[] args)</code></div>
    <div class="line number103 index102 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#123;</code></div>
    <div class="line number104 index103 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">MyStack s = </code><code class="keyword">new</code> <code class="plain">MyStack();</code>
    </div>
    <div class="line number105 index104 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">s.push(</code><code class="value">3</code><code class="plain">);</code></div>
    <div class="line number106 index105 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">s.push(</code><code class="value">5</code><code class="plain">);</code></div>
    <div class="line number107 index106 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">s.getMin();</code></div>
    <div class="line number108 index107 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">s.push(</code><code class="value">2</code><code class="plain">);</code></div>
    <div class="line number109 index108 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">s.push(</code><code class="value">1</code><code class="plain">);</code></div>
    <div class="line number110 index109 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">s.getMin();</code></div>
    <div class="line number111 index110 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">s.pop();</code></div>
    <div class="line number112 index111 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">s.getMin();</code></div>
    <div class="line number113 index112 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">s.pop();</code></div>
    <div class="line number114 index113 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">s.peek();</code></div>
    <div class="line number115 index114 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number116 index115 alt1"><code class="plain">&#125;</code></div>
</div>
   </div>
 <div id="tab-content-3" class="tab-content">
 <div class="container">
    <div class="line number1 index0 alt2"><code class="comments"># Class to make a Node</code></div>
    <div class="line number2 index1 alt1"><code class="keyword">class</code> <code class="plain">Node:</code></div>
    <div class="line number3 index2 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments"># Constructor which assign argument to nade's value</code></div>
    <div class="line number4 index3 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">def</code> <code class="plain">__init__(</code><code class="color1">self</code><code
            class="plain">, value):</code></div>
    <div class="line number5 index4 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1">self</code><code class="plain">.value </code><code class="keyword">=</code> <code
            class="plain">value</code></div>
    <div class="line number6 index5 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1">self</code><code class="plain">.</code><code class="functions">next</code> <code
            class="keyword">=</code> <code class="color1">None</code></div>
    <div class="line number7 index6 alt2">&nbsp;</div>
    <div class="line number8 index7 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments"># This method returns the string representation of the object.</code></div>
    <div class="line number9 index8 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">def</code> <code class="plain">__str__(</code><code class="color1">self</code><code
            class="plain">):</code></div>
    <div class="line number10 index9 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">return</code> <code class="string">"Node({})"</code><code class="plain">.</code><code
            class="functions">format</code><code class="plain">(</code><code class="color1">self</code><code
            class="plain">.value)</code></div>
    <div class="line number11 index10 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
    <div class="line number12 index11 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments"># __repr__ is same as __str__</code></div>
    <div class="line number13 index12 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">__repr__ </code><code class="keyword">=</code> <code class="plain">__str__</code></div>
    <div class="line number14 index13 alt1">&nbsp;</div>
    <div class="line number15 index14 alt2">&nbsp;</div>
    <div class="line number16 index15 alt1"><code class="keyword">class</code> <code class="plain">Stack:</code></div>
    <div class="line number17 index16 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments"># Stack Constructor initialise top of stack and counter.</code></div>
    <div class="line number18 index17 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">def</code> <code class="plain">__init__(</code><code class="color1">self</code><code
            class="plain">):</code></div>
    <div class="line number19 index18 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1">self</code><code class="plain">.top </code><code class="keyword">=</code> <code
            class="color1">None</code></div>
    <div class="line number20 index19 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1">self</code><code class="plain">.count </code><code class="keyword">=</code> <code
            class="value">0</code></div>
    <div class="line number21 index20 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1">self</code><code class="plain">.minimum </code><code class="keyword">=</code> <code
            class="color1">None</code></div>
    <div class="line number22 index21 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
    <div class="line number23 index22 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments"># This method returns the string representation of the object (stack).</code></div>
    <div class="line number24 index23 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">def</code> <code class="plain">__str__(</code><code class="color1">self</code><code
            class="plain">):</code></div>
    <div class="line number25 index24 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">temp </code><code class="keyword">=</code> <code class="color1">self</code><code
            class="plain">.top</code></div>
    <div class="line number26 index25 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">out </code><code class="keyword">=</code> <code class="plain">[]</code></div>
    <div class="line number27 index26 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">while</code> <code class="plain">temp:</code></div>
    <div class="line number28 index27 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">out.append(</code><code class="functions">str</code><code class="plain">(temp.value))</code>
    </div>
    <div class="line number29 index28 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">temp </code><code class="keyword">=</code> <code class="plain">temp.</code><code
            class="functions">next</code></div>
    <div class="line number30 index29 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">out </code><code class="keyword">=</code> <code class="string">'\n'</code><code
            class="plain">.join(out)</code></div>
    <div class="line number31 index30 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">return</code> <code class="plain">(</code><code
            class="string">'Top {} \n\nStack :\n{}'</code><code class="plain">.</code><code
            class="functions">format</code><code class="plain">(</code><code class="color1">self</code><code
            class="plain">.top,out))</code></div>
    <div class="line number32 index31 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
    <div class="line number33 index32 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments"># __repr__ is same as __str__</code></div>
    <div class="line number34 index33 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">__repr__</code><code class="keyword">=</code><code class="plain">__str__</code></div>
    <div class="line number35 index34 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
    <div class="line number36 index35 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments"># This method is used to get minimum element of stack</code></div>
    <div class="line number37 index36 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">def</code> <code class="plain">getMin(</code><code class="color1">self</code><code
            class="plain">):</code></div>
    <div class="line number38 index37 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">if</code> <code class="color1">self</code><code class="plain">.top </code><code
            class="keyword">is</code> <code class="color1">None</code><code class="plain">:</code></div>
    <div class="line number39 index38 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">return</code> <code class="string">"Stack is empty"</code></div>
    <div class="line number40 index39 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">else</code><code class="plain">:</code></div>
    <div class="line number41 index40 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">print</code><code class="plain">(</code><code
            class="string">"Minimum Element in the stack is: {}"</code> <code class="plain">.</code><code
            class="functions">format</code><code class="plain">(</code><code class="color1">self</code><code
            class="plain">.minimum))</code></div>
    <div class="line number42 index41 alt1">&nbsp;</div>
    <div class="line number43 index42 alt2">&nbsp;</div>
    <div class="line number44 index43 alt1">&nbsp;</div>
    <div class="line number45 index44 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments"># Method to check if Stack is Empty or not</code></div>
    <div class="line number46 index45 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">def</code> <code class="plain">isEmpty(</code><code class="color1">self</code><code
            class="plain">):</code></div>
    <div class="line number47 index46 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments"># If top equals to None then stack is empty</code></div>
    <div class="line number48 index47 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">if</code> <code class="color1">self</code><code class="plain">.top </code><code
            class="keyword">=</code><code class="keyword">=</code> <code class="color1">None</code><code
            class="plain">:</code></div>
    <div class="line number49 index48 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">return</code> <code class="color1">True</code></div>
    <div class="line number50 index49 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">else</code><code class="plain">:</code></div>
    <div class="line number51 index50 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments"># If top not equal to None then stack is empty</code></div>
    <div class="line number52 index51 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">return</code> <code class="color1">False</code></div>
    <div class="line number53 index52 alt2">&nbsp;</div>
    <div class="line number54 index53 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments"># This method returns length of stack&nbsp;&nbsp;&nbsp;&nbsp;</code></div>
    <div class="line number55 index54 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">def</code> <code class="plain">__len__(</code><code class="color1">self</code><code
            class="plain">):</code></div>
    <div class="line number56 index55 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1">self</code><code class="plain">.count </code><code class="keyword">=</code> <code
            class="value">0</code></div>
    <div class="line number57 index56 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">tempNode </code><code class="keyword">=</code> <code class="color1">self</code><code
            class="plain">.top</code></div>
    <div class="line number58 index57 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">while</code> <code class="plain">tempNode:</code></div>
    <div class="line number59 index58 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">tempNode </code><code class="keyword">=</code> <code class="plain">tempNode.</code><code
            class="functions">next</code></div>
    <div class="line number60 index59 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1">self</code><code class="plain">.count</code><code class="keyword">+</code><code
            class="keyword">=</code><code class="value">1</code></div>
    <div class="line number61 index60 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">return</code> <code class="color1">self</code><code class="plain">.count</code></div>
    <div class="line number62 index61 alt1">&nbsp;</div>
    <div class="line number63 index62 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments"># This method returns top of stack&nbsp;&nbsp;&nbsp;&nbsp;</code></div>
    <div class="line number64 index63 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">def</code> <code class="plain">peek(</code><code class="color1">self</code><code
            class="plain">):</code></div>
    <div class="line number65 index64 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">if</code> <code class="color1">self</code><code class="plain">.top </code><code
            class="keyword">is</code> <code class="color1">None</code><code class="plain">:</code></div>
    <div class="line number66 index65 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">print</code> <code class="plain">(</code><code class="string">"Stack is empty"</code><code
            class="plain">)</code></div>
    <div class="line number67 index66 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">else</code><code class="plain">:</code></div>
    <div class="line number68 index67 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">if</code> <code class="color1">self</code><code class="plain">.top.value &lt; </code><code
            class="color1">self</code><code class="plain">.minimum:</code></div>
    <div class="line number69 index68 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">print</code><code class="plain">(</code><code
            class="string">"Top Most Element is: {}"</code> <code class="plain">.</code><code
            class="functions">format</code><code class="plain">(</code><code class="color1">self</code><code
            class="plain">.minimum))</code></div>
    <div class="line number70 index69 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">else</code><code class="plain">:</code></div>
    <div class="line number71 index70 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="functions">print</code><code class="plain">(</code><code
            class="string">"Top Most Element is: {}"</code> <code class="plain">.</code><code
            class="functions">format</code><code class="plain">(</code><code class="color1">self</code><code
            class="plain">.top.value))</code></div>
    <div class="line number72 index71 alt1">&nbsp;</div>
    <div class="line number73 index72 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments"># This method is used to add node to stack</code></div>
    <div class="line number74 index73 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">def</code> <code class="plain">push(</code><code class="color1">self</code><code
            class="plain">,value):</code></div>
    <div class="line number75 index74 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">if</code> <code class="color1">self</code><code class="plain">.top </code><code
            class="keyword">is</code> <code class="color1">None</code><code class="plain">:</code></div>
    <div class="line number76 index75 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1">self</code><code class="plain">.top </code><code class="keyword">=</code> <code
            class="plain">Node(value)</code></div>
    <div class="line number77 index76 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1">self</code><code class="plain">.minimum </code><code class="keyword">=</code> <code
            class="plain">value</code></div>
    <div class="line number78 index77 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
    <div class="line number79 index78 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">elif</code> <code class="plain">value &lt; </code><code class="color1">self</code><code
            class="plain">.minimum:</code></div>
    <div class="line number80 index79 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">temp </code><code class="keyword">=</code> <code class="plain">(</code><code
            class="value">2</code> <code class="keyword">*</code> <code class="plain">value) </code><code
            class="keyword">-</code> <code class="color1">self</code><code class="plain">.minimum</code></div>
    <div class="line number81 index80 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">new_node </code><code class="keyword">=</code> <code class="plain">Node(temp)</code></div>
    <div class="line number82 index81 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">new_node.</code><code class="functions">next</code> <code class="keyword">=</code> <code
            class="color1">self</code><code class="plain">.top</code></div>
    <div class="line number83 index82 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1">self</code><code class="plain">.top </code><code class="keyword">=</code> <code
            class="plain">new_node</code></div>
    <div class="line number84 index83 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1">self</code><code class="plain">.minimum </code><code class="keyword">=</code> <code
            class="plain">value</code></div>
    <div class="line number85 index84 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">else</code><code class="plain">:</code></div>
    <div class="line number86 index85 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">new_node </code><code class="keyword">=</code> <code class="plain">Node(value)</code></div>
    <div class="line number87 index86 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">new_node.</code><code class="functions">next</code> <code class="keyword">=</code> <code
            class="color1">self</code><code class="plain">.top</code></div>
    <div class="line number88 index87 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1">self</code><code class="plain">.top </code><code class="keyword">=</code> <code
            class="plain">new_node</code></div>
    <div class="line number89 index88 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">print</code><code class="plain">(</code><code class="string">"Number Inserted: {}"</code>
        <code class="plain">.</code><code class="functions">format</code><code class="plain">(value))</code></div>
    <div class="line number90 index89 alt1">&nbsp;</div>
    <div class="line number91 index90 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments"># This method is used to pop top of stack</code></div>
    <div class="line number92 index91 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">def</code> <code class="plain">pop(</code><code class="color1">self</code><code
            class="plain">):</code></div>
    <div class="line number93 index92 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">if</code> <code class="color1">self</code><code class="plain">.top </code><code
            class="keyword">is</code> <code class="color1">None</code><code class="plain">:</code></div>
    <div class="line number94 index93 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="functions">print</code><code class="plain">( </code><code class="string">"Stack is empty"</code><code
            class="plain">)</code></div>
    <div class="line number95 index94 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">else</code><code class="plain">:</code></div>
    <div class="line number96 index95 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">removedNode </code><code class="keyword">=</code> <code class="color1">self</code><code
            class="plain">.top.value</code></div>
    <div class="line number97 index96 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1">self</code><code class="plain">.top </code><code class="keyword">=</code> <code
            class="color1">self</code><code class="plain">.top.</code><code class="functions">next</code></div>
    <div class="line number98 index97 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">if</code> <code class="plain">removedNode &lt; </code><code class="color1">self</code><code
            class="plain">.minimum:</code></div>
    <div class="line number99 index98 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="functions">print</code> <code class="plain">(</code><code
            class="string">"Top Most Element Removed :{} "</code> <code class="plain">.</code><code
            class="functions">format</code><code class="plain">(</code><code class="color1">self</code><code
            class="plain">.minimum))</code></div>
    <div class="line number100 index99 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1">self</code><code class="plain">.minimum </code><code class="keyword">=</code> <code
            class="plain">( ( </code><code class="value">2</code> <code class="keyword">*</code> <code
            class="color1">self</code><code class="plain">.minimum ) </code><code class="keyword">-</code> <code
            class="plain">removedNode )</code></div>
    <div class="line number101 index100 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">else</code><code class="plain">:</code></div>
    <div class="line number102 index101 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="functions">print</code> <code class="plain">(</code><code
            class="string">"Top Most Element Removed : {}"</code> <code class="plain">.</code><code
            class="functions">format</code><code class="plain">(removedNode))</code></div>
    <div class="line number103 index102 alt2">&nbsp;</div>
    <div class="line number104 index103 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;
    </div>
    <div class="line number105 index104 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;
    </div>
    <div class="line number106 index105 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
    <div class="line number107 index106 alt2"><code class="comments"># Driver program to test above class</code></div>
    <div class="line number108 index107 alt1"><code class="plain">stack </code><code class="keyword">=</code> <code
            class="plain">Stack()</code></div>
    <div class="line number109 index108 alt2">&nbsp;</div>
    <div class="line number110 index109 alt1"><code class="plain">stack.push(</code><code class="value">3</code><code
            class="plain">)</code></div>
    <div class="line number111 index110 alt2"><code class="plain">stack.push(</code><code class="value">5</code><code
            class="plain">)</code></div>
    <div class="line number112 index111 alt1"><code class="plain">stack.getMin()</code></div>
    <div class="line number113 index112 alt2"><code class="plain">stack.push(</code><code class="value">2</code><code
            class="plain">)</code></div>
    <div class="line number114 index113 alt1"><code class="plain">stack.push(</code><code class="value">1</code><code
            class="plain">)</code></div>
    <div class="line number115 index114 alt2"><code class="plain">stack.getMin()&nbsp;&nbsp;&nbsp;&nbsp;</code></div>
    <div class="line number116 index115 alt1"><code class="plain">stack.pop()</code></div>
    <div class="line number117 index116 alt2"><code class="plain">stack.getMin()</code></div>
    <div class="line number118 index117 alt1"><code class="plain">stack.pop()</code></div>
    <div class="line number119 index118 alt2"><code class="plain">stack.peek()</code></div>
    <div class="line number120 index119 alt1">&nbsp;</div>
    <div class="line number121 index120 alt2"><code class="comments"># This code is contributed by Blinkii</code></div>
</div>
</div>
 
</div>
</div>
<br /> <br /> <br /> <br /> <br />
    </div>
    )
}

export default Flpkrt6
